export default __webpack_public_path__ + "static/media/slideup1.a0cbed4c.jpeg";